<template>
  <div>
    <bet-rule-acceptance v-if="false"></bet-rule-acceptance>
    <v-container fluid class="py-0">
      <v-row>
        <v-col
          v-if="
            ($breakpoint.mdAndUp && $auth.user) ||
            (!$auth.user && $breakpoint.mdAndUp)
          "
          cols="12"
          md="3"
          lg="2"
        >
          <sportsbook-category :orientation="'vertical'"></sportsbook-category>
        </v-col>
        <v-col
          :md="!$auth.user ? 9 : 9"
          :lg="!$auth.user ? 10 : 10"
          style="margin-top: 4px; padding: 12px 8px"
        >
          <div
            v-if="($auth.user && $auth.user) || !$auth.user"
            :class="{ white: !$vuetify.theme.dark }"
          >
            <slider></slider>
            <v-row class="margin-top ma-0">
              <v-col cols="12" sm="12" md="12" class="pa-0">
                <!-- <free-bet-card /> -->
                <inplay class="mt-1" />
                <v-card style="border-radius: 16px">
                  <live-cards
                    :card-title="gamesTitle[0]"
                    :games-array="cardsArray"
                  />
                  <live-cards
                    :card-title="gamesTitle[1]"
                    :games-array="casinoArray"
                  />
                </v-card>
                <v-row
                  class="mb-4 mt-1 sport-book"
                  :class="{
                    'pt-1 px-3': $breakpoint.smAndDown
                  }"
                >
                  <v-col
                    cols="12"
                    md="12"
                    sm="12"
                    :class="{
                      'py-1 px-0': $breakpoint.smAndDown
                    }"
                  >
                    <v-card ripple tile flat to="/premium-sportsbook">
                      <v-img
                        cover
                        :aspect-ratio="900 / 160"
                        :src="require('@/assets/images/index/premium.gif')"
                        :lazy-src="require('@/assets/images/index/premium.gif')"
                        alt="premium sportsbook banner image"
                      ></v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <upcoming />
                <v-row
                  class="mb-1 mt-1"
                  :class="{
                    'px-3': $breakpoint.smAndDown
                  }"
                >
                  <v-col
                    cols="12"
                    sm="6"
                    :class="{
                      'py-0 px-0': $breakpoint.smAndDown
                    }"
                  >
                    <v-card ripple tile flat to="/live-cards">
                      <v-img
                        v-if="!$breakpoint.smAndDown"
                        cover
                        :aspect-ratio="900 / 160"
                        :src="
                          require('@/assets/images/index/live-cards-banner2.gif')
                        "
                        :lazy-src="
                          require('@/assets/images/index/live-cards-banner2.gif')
                        "
                        alt="live cards banner image"
                      ></v-img>
                      <v-img
                        v-if="$breakpoint.smAndDown"
                        cover
                        :aspect-ratio="900 / 160"
                        :src="
                          require('@/assets/images/index/live-cards-mob.gif')
                        "
                        :lazy-src="
                          require('@/assets/images/index/live-cards-mob.gif')
                        "
                        alt="live cards banner mob image"
                      ></v-img>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    :class="{
                      'py-1 px-0': $breakpoint.smAndDown
                    }"
                  >
                    <v-card ripple tile flat to="/casino/live-casino">
                      <v-img
                        v-if="!$breakpoint.smAndDown"
                        cover
                        :aspect-ratio="900 / 160"
                        :src="
                          require('@/assets/images/index/live-casino-banner2.gif')
                        "
                        :lazy-src="
                          require('@/assets/images/index/live-casino-banner2.gif')
                        "
                        alt="live casino banner image"
                      ></v-img>
                      <v-img
                        v-if="$breakpoint.smAndDown"
                        cover
                        :aspect-ratio="900 / 160"
                        :src="
                          require('@/assets/images/index/live-casino-mob.gif')
                        "
                        :lazy-src="
                          require('@/assets/images/index/live-casino-mob.gif')
                        "
                        alt="live casino banner mob image"
                      ></v-img>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <div class="download-apk-image">
        <v-img
          :src="imageSrc"
          cover
          min-height="276"
          aspect-ratio="16/9"
          @click="downloadApk()"
        >
        </v-img>
      </div>
    </v-container>
    <welcome-modal v-if="$auth.loggedIn" />
    <cookies-acceptance v-if="$auth.loggedIn" />
    <action-buttons v-if="$breakpoint.mdAndUp" />
    <draggable-button
      v-if="
        !$auth.loggedIn &&
        getWhatsappData &&
        getWhatsappData.isWhatsAppNo &&
        getWhatsappData.number
      "
      :is-click.sync="btnIsClick"
    >
      <div v-if="$breakpoint.smAndDown" draggable>
        <div
          v-if="
            getWhatsappData &&
            getWhatsappData.isWhatsAppNo &&
            getWhatsappData.number &&
            getWhatsappData.whatsAppLink &&
            dialogtextm
          "
          class="whatsapptextm"
        >
          <v-badge offset-x="-4" color="grey lighten-3">
            <v-icon class="closeIcon" @click="dialogtextm = fasle"
              >mdi-close</v-icon
            >
            <div>
              <span class="black--text mb-2 caption font-weight-bold"
                >Get an ID instantly on Whatsapp.
              </span>
              <br />
              <a
                class="text-decoration-underline caption black--text"
                @click="goToWhatsapp()"
                >Click Here Now</a
              >
            </div>
          </v-badge>
        </div>
        <v-btn
          large
          class="search-one icon-whatsapp float-whatsappMob mt-16"
          fixed
          fab
          color="#000000"
          height="68"
          width="68"
          aria-label="whatsapp"
          @click="goToWhatsapp()"
        >
          <v-icon size="45" color="#33e675">mdi-whatsapp</v-icon>
        </v-btn>
      </div>
    </draggable-button>
    <footer-menu class="footer-menu d-none-pc" />
  </div>
</template>

<script>
import { load } from '@fingerprintjs/fingerprintjs'
import { mapState } from 'vuex'
import remove from 'lodash/remove'
import constants from '../constant'
import Slider from '@/components/fairplay/Home/Slider'
import Inplay from '@/components/sections/Inplay'
import Upcoming from '@/components/sections/Upcoming'
import SportsbookCategory from '@/components/sections/SportsbookCategory'
import BetRuleAcceptance from '@/components/BetRuleAcceptance'
import WelcomeModal from '@/components/fairplay/modals/WelcomeModal'
import CookiesAcceptance from '@/components/CookiesAcceptance'
import ActionButtons from '@/components/fairplay/ActionButtons'
import LiveCards from '~/components/LiveCards.vue'
import FooterMenu from '@/components/sections/FooterMenu'
import encryptor from '~/plugins/encryption.js'

export default {
  name: 'HomePage',
  components: {
    Slider,
    Inplay,
    Upcoming,
    BetRuleAcceptance,
    SportsbookCategory,
    WelcomeModal,
    CookiesAcceptance,
    ActionButtons,
    LiveCards,
    FooterMenu
  },
  data() {
    return {
      CDN_IMG_URL: process.env.CDN_IMG_URL,
      domain: process.env.DOMAIN_NAME,
      environment: process.env.fairplayEnvironment,
      currentLoaderStatus: false,
      btnIsClick: false,
      windowWidth: 0,
      colors: [
        'indigo',
        'warning',
        'pink darken-2',
        'red lighten-1',
        'deep-purple accent-4'
      ],
      dialogtextm: true,
      userName: '',
      gamesTitle: ['Cards', 'Casino'],
      cardsArray: [
        {
          title: 'Teenpatti',
          img: 'teenpatti.png',
          id: '567671'
        },
        {
          title: 'Hi Low',
          img: 'hi-lo.png',
          id: '569681'
        },
        {
          title: 'Andar Bahar',
          img: 'andar-bahar.png',
          id: '875641'
        },
        {
          title: '2 Card Teenpatti',
          img: '2-card-teenpatti.png',
          id: '676602'
        },
        {
          title: 'Amar Akbar Anthony',
          img: 'amar-akbar.png',
          id: '987912'
        },
        {
          title: '32 Card Casino',
          img: '32-card-casino.png',
          id: '569672'
        }
      ],
      casinoArray: [
        {
          title: 'Roulette',
          img: 'roulette.png',
          id: 'EVOLUTION-goldvaultroulette-GoldVaultRo00001'
        },
        {
          title: 'Lightning Dice',
          img: 'lightning-dice.png',
          id: 'LightningDT00001'
        },
        {
          title: 'Crazy Time',
          img: 'crazy-time.png',
          id: 'EVOLUTION-crazytime-CrazyTime0000001'
        },
        {
          title: 'Deal No Deal',
          img: 'deal-no-deal.png',
          id: 'EVOLUTION-dealnodeal-dealnodeal000001'
        },
        {
          title: 'Money Wheel',
          img: 'money-wheel.png',
          id: 'EVOLUTION-moneywheel-nvrpo3bv6teqkuco'
        },
        {
          title: 'Dragon Tiger',
          img: 'dragon-tiger.png',
          id: 'EVOLUTION-DragonTiger-puu47n7mic3rfd7y'
        }
      ]
    }
  },
  head() {
    return {
      title: 'Online Betting Site | Sports Betting in India | Cricplay',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Cricplay is the best online betting site in India. Bigger, faster profits only in Cricplay. You can start sports betting online today and get a huge bonus on your first deposit.'
        },
        {
          name: 'keywords',
          content:
            'Play and win cash, Games to win money, cash winning games, sports betting, online cricket betting, Indian card games, online casino'
        }
      ]
    }
  },
  computed: {
    balanceSettings: (state) => state.settings.balanceSettings,
    ...mapState({
      // threeEtMarkets: (state) => state.threeEt.untouched,
      sportsbookCategories: (state) => state.sportsbookCategory.data,
      loading: (state) => state.sportsbookCategory.loading,
      homeLoading: (state) => state.home.loading,
      getWhatsappData: (state) => state.user.whatsappData
    }),
    userProfile() {
      return this.$store.state.profile.data
    },
    imageSrc() {
      if (this.windowWidth <= 424) {
        return require('@/assets/images/download-apk-mobile.png')
      }
      if (this.windowWidth <= 768) {
        return require('@/assets/images/download-apk-md.png')
      }
      return require('@/assets/images/download-apk-pc.png')
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newVal) {
        if (newVal.token) {
          this.setToken(newVal.token)
        }
      }
    },
    homeLoading() {
      this.currentLoaderStatus = this.homeLoading
    }
  },
  created() {
    if (!this.balanceSetting) {
      this.$store.dispatch('settings/balanceSettings')
    }
    if (this.$route?.query?.atag) {
      // save atag in cookie
      const d = new Date()
      d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000)
      const expires = `expires=${d.toUTCString()}`
      // eslint-disable-next-line nuxt/no-globals-in-created
      document.cookie = `atag=${this.$route.query.atag}; SameSite=None; Secure; ${expires}`
      localStorage.setItem('atag', this.$route.query.atag)
    }
    if (this.$route?.query?.clickId) {
      const d = new Date()
      d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000)
      const expires = `expires=${d.toUTCString()}`
      // eslint-disable-next-line nuxt/no-globals-in-created
      document.cookie = `clickId=${this.$route.query.clickId}; SameSite=None; Secure; ${expires}`
      localStorage.setItem('clickId', this.$route.query.clickId)
    }
    if (this.$route?.query?.btag) {
      this.btag = this.$route.query.btag
      const d = new Date()
      d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000)
      const expires = `expires=${d.toUTCString()}`
      // eslint-disable-next-line nuxt/no-globals-in-created
      document.cookie = `fairplay_affilates=${this.$route.query.btag}; SameSite=None; Secure; ${expires}`
    }
    // let userId
    if (this.$auth.loggedIn) {
      this.activeGames()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth)
  },
  mounted() {
    this.updateWidth()
    window.addEventListener('resize', this.updateWidth)
    this.generateFingerprintId()
    if (!this.$cookies.get('_fbc')) {
      this.setFbClickId()
    }
  },
  methods: {
    async generateFingerprintId() {
      try {
        const fp = await load()
        const result = await fp.get()
        this.$store.commit('profile/set_fingerprintId', result.visitorId)
      } catch (error) {
        console.log('error', error)
      }
    },
    setFbClickId() {
      const fbClickIdFinal = Date.now()
      const _fbc = `fb.1.${Date.now()}.${fbClickIdFinal}`
      this.$cookies.set('_fbc', _fbc, '90d')
    },
    setToken(token) {
      localStorage.setItem('accessToken', token)
      localStorage.setItem('auth._token.customLocal', token)
      localStorage.setItem('auth.strategy', 'customLocal')
      localStorage.setItem('auth._refresh_token.customLocal', 'false')
      const base64Url = token.split('.')[1]
      const base64 =
        base64Url.replace(/-/g, '+').replace(/_/g, '/') +
        '=='.slice(0, (3 * base64Url.length) % 4)
      const payload = JSON.parse(atob(base64))
      localStorage.setItem('auth.userConfig', JSON.stringify(payload))
      localStorage.setItem(
        'getOneUser',
        encryptor.encrypt(JSON.stringify(payload))
      )
      localStorage.setItem(
        'userRes',
        encryptor.encrypt(JSON.stringify(payload))
      )
      this.userName = payload.loginName
      localStorage.setItem('userName', this.userName)
    },
    updateWidth() {
      this.windowWidth = window.innerWidth
    },
    goToWhatsapp() {
      if (this.getWhatsappData?.number && this.getWhatsappData.whatsAppLink) {
        window.open(this.getWhatsappData.whatsAppLink)
      }
    },
    goToTelegram() {
      window.open(process.env.TELEGRAM_URL)
    },
    downloadApk() {
      document.location = constants.fairplayAPK
    },
    activeGames() {
      this.gamesList = remove(this.gamesList, (game) => {
        if (this.$auth.user.casino && game.title === 'LiveCasino') {
          return game
        }
        if (this.$auth.user.cardgame && game.title === 'LiveCards') {
          return game
        }
      })
    },
    saveImpression(path) {
      this.$store.dispatch('ip/saveImpression', path)
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card.on-hover.theme--dark {
  background-color: rgba(#fff, 0.8);
  .v-card__text {
    color: #000;
  }
}
.sport-book {
  margin-bottom: 0px !important;
}
.backIcon {
  right: 4%;
  bottom: 12%;
  top: unset;
  left: unset;
}
.v-card {
  background: #121212;
}
@media (min-width: 768px) {
  .v-card {
    display: flex;
    gap: 8px;
  }
}
.footer-menu {
  position: fixed;
  bottom: 0;
  z-index: 1;
}
@media (min-width: 768px) and (max-width: 960px) {
  .margin-top {
    margin-top: 10px;
  }
}
// if width is greater than 860 then hide the footer
@media (min-width: 961px) and (max-width: 1250px) {
  .d-none-pc {
    display: none;
  }
  .margin-top {
    margin-top: 10px;
  }
}
@media (min-width: 1251px) and (max-width: 1600px) {
  /* Your CSS styles for this range of screen sizes */
  .margin-top {
    margin-top: 56px !important;
  }
}
</style>
